import { render, staticRenderFns } from "./ProjectAccessRequestTable.vue?vue&type=template&id=d105bd98&scoped=true&"
import script from "./ProjectAccessRequestTable.vue?vue&type=script&lang=js&"
export * from "./ProjectAccessRequestTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAccessRequestTable.vue?vue&type=style&index=0&id=d105bd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d105bd98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VDataTable,VSelect,VTooltip})
